import * as THREE from 'three';
import * as CANNON from 'cannon-es';

class CameraEngineChaseCopter {
	// камера, автоматически преследующая машину игрока, держится сверху-сзади, смотрит на машину 
	
	camera: THREE.PerspectiveCamera;
	
//	mode = 0;  // 0 - стоим на месте, 1 - догоняем

	constructor(scene: THREE.Scene, position: CANNON.Vec3, quaternion: CANNON.Quaternion) {

		this.camera = new THREE.PerspectiveCamera( 35, window.innerWidth / window.innerHeight, 0.01, 1000 );
		this.camera.position.set(30, -10, 10);
		this.camera.lookAt(0, 0, 0);
		
		scene.add(this.camera);
		
		
	}
	/////////////////////////////////////////////////////////
	animate(position: CANNON.Vec3, quaternion: CANNON.Quaternion) {
		
		// замеряем расстояние от камеры до объекта
//		const distance = this.camera.position.distanceTo(position);
			
//		console.log("position: " + position.x + ", " + position.y + ", " + position.z);
//		console.log("camera.position: " + this.camera.position.x + ", " + this.camera.position.y + ", " + this.camera.position.z);
//		console.log("distance = " + distance);

//		this.camera.position.y = position.y + 1;
		
		// удерживаем камеру на расстоянии
//		const euler:CANNON.Vec3 = new CANNON.Vec3();
//		quaternion.toEuler(euler);
//		euler.normalize();
				
		const distance1 = 7;

		const v = new THREE.Vector3( 0, 0, 1 ).applyQuaternion( quaternion );

		const camPosition: THREE.Vector3 = new THREE.Vector3( position.x, position.y, position.z).add( v.multiplyScalar( distance1 ) );				
				
		this.camera.position.x = camPosition.x; 
		this.camera.position.y = camPosition.y + 1; 
		this.camera.position.z = camPosition.z; 
				
		// смотрим на машину и чуть выше
		this.camera.lookAt(new THREE.Vector3(position.x, position.y + 1.5, position.z));
	}
	/////////////////////////////////////////////////////////
	getCamera() {
		return this.camera;
	}
	/////////////////////////////////////////////////////////
	
}
export default CameraEngineChaseCopter;